import moment from 'moment';
import { type NullableMoment } from '@features/AvailabilityPresentation/Calendar/Calendar.interfaces';
import { getParam } from './url.utils';

export const formatMomentToString = (date?: NullableMoment) => {
  if (!date?.isValid()) {
    return '';
  }

  return date.format('YYYY-MM-DD');
};

export const formatMomentToShortenedString = (date?: NullableMoment) => {
  if (!date?.isValid()) {
    return '';
  }

  return date.format('ddd D MMM');
};

// Expects date in format 'YYYY-MM-DD'
export const firstDayOfMonth = (date: string) => {
  if (!date) {
    return '';
  }

  return `${date.slice(0, -2)}01`;
};

export const createMomentFromParam = (param: string, locale: string) => {
  const dateParam = getParam(param);

  if (!dateParam) {
    return null;
  }

  const momentDate = /\d{2}\/\d{2}\/\d{4}/.exec(dateParam)
    ? moment(dateParam, 'DD/MM/YYYY', true).locale(locale)
    : moment(dateParam, true).locale(locale);

  return momentDate.isValid() ? momentDate : null;
};

export const isSameDay = (baseDate: NullableMoment, dateToCompare: NullableMoment) => {
  if (!baseDate || !dateToCompare) {
    return false;
  }
  return (
    baseDate.date() === dateToCompare.date() &&
    baseDate.month() === dateToCompare.month() &&
    baseDate.year() === dateToCompare.year()
  );
};

export const getCurrentDateTime = () => {
  return moment();
};
